import React from "react";
import { useTranslation } from "react-i18next";
import "./style.css";
export const Experiencia = () => {
	const [t] = useTranslation("global");

	const data = [
		{
			puesto: t("trabajo"),
			fecha: "12/02/2021 - " + t("actualidad"),
			pointer: true,
			funciones: [t("funciones.3"), t("funciones.1"), t("funciones.2")],
			proyetos: [
				t("proyectos.5"),
				t("proyectos.1"),
				t("proyectos.2"),
				t("proyectos.3"),
				t("proyectos.4"),
			],
		},
	];

	return (
		<div>
			<br />
			<br />
			<br />

			<div className="flex flex-col justify-center items-center my-8  w-full bg-gray-900">
				<br />
				<br />
				<br />
				<h2 className="text-center text-yellow-300 font-Montserrat font-bold text-smt tabletbig:text-2xl">
					{t("experiencia")}
				</h2>
				<br />
				<br />
				<div>
					{data.map((item, index) => (
						<div key={index}>
							<div className={`flex justify-between w-96/0 mx-5`}>
								{
									// Puesto de trabajo 1° Linea
								}
								<div className="flex flex-col mx-2">
									<p className="font-Poppins font-semibold text-yellow-300 text-smt tabletbig:text-2s">
										{item.puesto}
									</p>
									<p className="font-Poppins font-medium text-yellow-300 text-smt tabletbig:text-1s">
										{item.fecha}
									</p>
								</div>

								{
									// linea de color y bolita 2° Linea
								}
								<div
									className={`hidden tabletbig:flex flex-col g justify-center items-center mx-2 ${
										!item.pointer && "relative -top-4"
									}`}
								>
									<div
										className={`w-9 h-9 rounded-full bg-white ${
											!item.pointer && "blanck"
										}`}
									></div>

									<div className="w-3 h-3/4 rounded-full bg-white relative -top-2"></div>
								</div>

								{
									// funciones  y proyetos 3° Linea
								}
								<div className="mx-2">
									<p className="font-Poppins font-bold text-yellow-300 text-smt tabletbig:text-2xl">
										{t("funciones")}
									</p>
									<ul>
										{item.funciones.map((i, index) => (
											<li
												className="font-Poppins font-medium text-gray-300 text-smt tabletbig:text-2s my-2"
												key={index}
											>
												{i}
											</li>
										))}
									</ul>
									<br />
									<p className="font-Poppins font-bold text-yellow-300 text-smt tabletbig:text-2xl">
										{t("projects")}
									</p>
									<ul>
										{item.proyetos.map((p, index) => (
											<li
												className="font-Poppins font-medium text-gray-300 text-smt tabletbig:text-2s my-2"
												key={index}
											>
												{p}
											</li>
										))}
									</ul>
								</div>
							</div>
						</div>
					))}
				</div>
				<br />
				<br />
				<br />
			</div>
		</div>
	);
};
